<template>
  <div class="app-container cheliang-page">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CheliangPageWrap'
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';
</style>
